import React, { useState, useContext } from "react";
import { styled, alpha } from "@mui/material/styles";

import {
    Typography,
    Button,
    Menu,
    MenuItem,
    Divider,
    Stack,
    Tooltip,
    Box,
    IconButton
} from "@mui/material";

// icon
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { RiUserUnfollowFill } from "react-icons/ri";

// src
import "../../Style/actionStyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";

import StudentDropOut from "../Students/StudentDetail/StudentEnrollment/StudentDropOut"


export default function ViewAttendancePageAction({
    enrollmentTypeAction,
    setRefetch,
    dataStuAttended,
}) {


    // ===================== Change Language ==========================
    const { language, setAlert } = useContext(AuthContext);
    const { t } = translateLauguage(language);

    const [openDropOut, setOpenDropOut] = useState(false);
    const handleOpenDropOut = () => setOpenDropOut(true);
    const handleCloseDropOut = () => setOpenDropOut(false);

    return (
        <div>
            <Stack direction="row" justifyContent="right">
                <Tooltip title={t("drop_out")} placement="top">
                    <IconButton onClick={handleOpenDropOut}>
                        <Box className="delete-container">
                            <RiUserUnfollowFill className="delete-icon" />
                        </Box>
                    </IconButton>
                </Tooltip>
            </Stack>

            {
                openDropOut && (
                    <StudentDropOut open={openDropOut} dataStuAttended={dataStuAttended} handleClose={handleCloseDropOut} enrollmentTypeAction={enrollmentTypeAction} setRefetch={setRefetch} />
                )
            }

        </div>
    )
}
